'use client';
import { FormControlLabel as FormControlLabelMui } from '@mui/material';

const FormControlLabel = FormControlLabelMui;

export default FormControlLabel;
